import { Sort }              from 'Components/Sort';
import { Filters }           from 'Components/Filters/Filters';
import * as selectric        from 'selectric';

// HACK: mismatch in the module resolution. We need to actually init selectric this way in order to be able to call `$().selectric()` in modules listed below
selectric();

export {
    Filters,
    Sort
}
import { Sort }              from 'Components/Sort';
import { Filters }           from 'Components/Filters/Filters';
import * as selectric        from 'selectric';

// HACK: mismatch in the module resolution. We need to actually init selectric this way in order to be able to call `$().selectric()` in modules listed below
selectric();

export {
    Filters,
    Sort
}
